import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'read-article',
  templateUrl: './read-article.component.html',
  styleUrls: ['./read-article.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReadArticleComponent implements AfterViewInit {
  @Input() text: string;

  @Input() maxHeight = 340;

  public isCollapsed$ = new BehaviorSubject<Boolean>(false);
  public isCollapsable$ = new BehaviorSubject<Boolean>(false);

  constructor(
    private elementRef: ElementRef,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    const currentHeight = this.elementRef.nativeElement.getElementsByTagName(
      'div'
    )[0].offsetHeight;

    if (currentHeight > this.maxHeight) {
      this.isCollapsed$.next(true);
      this.isCollapsable$.next(true);
      this.cd.detectChanges();
    }
  }

  toggleCollapse(): void {
    this.isCollapsed$.next(!this.isCollapsed$.value);
  }
}
